import React, { useEffect } from "react";
import BrandLogo from "./BrandLogo";

export default function Loader({ onDone }) {
  const [phase, setPhase] = React.useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 1900);
    const t2 = setTimeout(() => onDone && onDone(), 2400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div
      data-testid="app-loader"
      className="app-loader"
      style={{
        opacity: phase === 1 ? 0 : 1,
        pointerEvents: phase === 1 ? "none" : "auto",
      }}
    >
      <div className="pulse-glow loader-ring loader-ring-a" />
      <div className="loader-ring loader-ring-b" />
      <div className="loader-ring loader-ring-c rotate-slow" />

      <div className="loader-mark">
        <BrandLogo className="loader-logo" size="auto" plate />
      </div>

      <div className="loader-sweep" />
    </div>
  );
}
